<template>
  <b-badge
    class="sr-status-badge"
    pill
    :style="style"
  >
    {{ text }}
  </b-badge>
</template>

<script>

export default {
    name: 'AttachmentCountBadge',
    props: {
        count: { type: Number, default: 0 }
    },
    computed: {
        style() {
            return { 'background-color': '#40c6c2' }
        },
        color() {
            return '#ffffff'
        },
        text() {
            if (this.count > 0) {
                return this.count
            } else {
                return ''
            }
        }
    }
}

</script>

<style scoped lang="scss">

.sr-status-badge {
  width: 25px;
}

</style>
